import { render, staticRenderFns } from "./ConciergesTable.vue?vue&type=template&id=c71d4f12"
import script from "./ConciergesTable.vue?vue&type=script&lang=js"
export * from "./ConciergesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports